import type {SubmenuNavItem} from '../types';

export function isLinkActive(
    match: boolean,
    pathname: string,
    search: string,
    activeMatch?: RegExp,
    searchMatch?: RegExp
): boolean {
    if (activeMatch && searchMatch) {
        return activeMatch.test(pathname) && searchMatch.test(search);
    } else if (activeMatch) {
        return activeMatch.test(pathname);
    }

    return match;
}

export function isSubmenuItemActive(
    submenuItem: SubmenuNavItem,
    location: {
        pathname: string;
        search: string;
    }
): boolean {
    // Check if submenuItem has activeMatch pattern
    if (submenuItem.activeMatch) {
        return submenuItem.activeMatch.test(location.pathname);
    }

    // Check if submenuItem has searchMatch pattern and it needs to match both
    if (submenuItem.activeMatch && submenuItem.searchMatch) {
        return (
            // @ts-expect-error
            submenuItem.activeMatch.test(location.pathname) &&
            submenuItem.searchMatch &&
            submenuItem.searchMatch.test(location.search)
        );
    }

    // Fallback to the original path matching logic
    return submenuItem.to.includes(location.pathname) || location.pathname.includes(submenuItem.to);
}
